import React from 'react';
import { KatButton, KatLabel } from '@amzn/katal-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { EventHandler } from '../../utils/customEventHandler'

import '../App.scss';

export class InterimSteps extends React.Component {

    state = {
        outputHeaders: '',
        requestBody: '',
        canonicalRequest: '',
        stringToSign: ''
    }

    handleEvent = (event) => {
        this.setState({
            outputHeaders: event.detail.outputHeaders,
            requestBody: event.detail.payload,
            canonicalRequest: event.detail.canonicalRequest,
            stringToSign: event.detail.stringToSign
        });
    };

    componentDidMount() {
        EventHandler.subscribe('apiEvent', this.handleEvent);
    }

    componentWillUnmount() {
        EventHandler.unsubscribe('apiEvent', this.handleEvent);
    }

    render() {
        return (
            <div>
                <KatLabel
                    emphasis="Request Headers"
                    tooltipText="All headers sent as part of the API call. Note that the authorization header is never part of the signed headers, because it contains the signature and can't be self-referenced. Also, Scratchpad does not sign the user-agent header because some browsers will override the value specified by applications run using a browser's fetch() call."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.outputHeaders}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.outputHeaders}</pre>

                <KatLabel
                    emphasis="Request Body"
                    tooltipText="JSON string representing the API request payload. This example sends it in a pretty-print fashion for readability, but most applications send the JSON string as a single line of text."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.requestBody}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.requestBody}</pre>

                <KatLabel
                    emphasis="Canonical Request"
                    tooltipText="HTTP method on first line; followed by URL path for API call; a blank line; all signed header keys and values, sorted alphabetically by key name; a blank line; then the header keys only, again alphabetically, separately by just a semicolon on same line; and finally, on the last line, the SHA256 hash of the JSON payload in hexidecimal format."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.canonicalRequest}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.canonicalRequest}</pre>

                <KatLabel
                    emphasis="String to Sign"
                    tooltipText="A hardcoded string representing the Amazon Pay signature algorithm on the first line and the SHA256 hash of the Canonical Request, in hexidecimal format, on the second line."
                />
                <br/><br/>
                <CopyToClipboard text={this.state.stringToSign}>
                    <KatButton label="Copy" size="small" variant="primary" className="btn-copy"/>
                </CopyToClipboard>
                <pre>{this.state.stringToSign}</pre>
            </div>
        );
    }
}

export default InterimSteps;
